import type { ILog } from '@monofe/util';
import type { Dispatch, Middleware, MiddlewareAPI } from '@reduxjs/toolkit';

const builderLoggerMiddleware = (logger: ILog) => {
    const loggerMiddleware: Middleware =
        ({ getState }: MiddlewareAPI) =>
        (next: Dispatch) =>
        action => {
            logger.verbose(`Dispatching ${JSON.stringify(action)}`);

            /* eslint-disable-next-line @typescript-eslint/no-unsafe-assignment */
            const returnValue = next(action);

            logger.verbose(`State post dispatch ${JSON.stringify(getState())}`);

            /* eslint-disable-next-line @typescript-eslint/no-unsafe-return */
            return returnValue;
        };

    return loggerMiddleware;
};

export default builderLoggerMiddleware;
